import { lazy } from 'react';
import { D as DefaultTranslationComp } from './en-US-5d5969e7.js';

/* eslint-disable quotes, quote-props, comma-dangle, max-len */
// eslint-disable-next-line @typescript-eslint/no-unused-vars

const translationImports = {
  'ar-AE': () => import( /* webpackChunkName: "storm-ui--ChatBoxInput--ar-AE" */'./ar-AE-3cda0059.js'),
  'de-DE': () => import( /* webpackChunkName: "storm-ui--ChatBoxInput--de-DE" */'./de-DE-dbd16f05.js'),
  'en-AU': () => import( /* webpackChunkName: "storm-ui--ChatBoxInput--en-AU" */'./en-AU-afc81450.js'),
  'en-CA': () => import( /* webpackChunkName: "storm-ui--ChatBoxInput--en-CA" */'./en-CA-23fcd9c6.js'),
  'en-GB': () => import( /* webpackChunkName: "storm-ui--ChatBoxInput--en-GB" */'./en-GB-89f87cd9.js'),
  'en-IN': () => import( /* webpackChunkName: "storm-ui--ChatBoxInput--en-IN" */'./en-IN-a0823bbc.js'),
  'en-SG': () => import( /* webpackChunkName: "storm-ui--ChatBoxInput--en-SG" */'./en-SG-1f28709b.js'),
  'es-CO': () => import( /* webpackChunkName: "storm-ui--ChatBoxInput--es-CO" */'./es-CO-451c246b.js'),
  'es-ES': () => import( /* webpackChunkName: "storm-ui--ChatBoxInput--es-ES" */'./es-ES-b61422e4.js'),
  'es-MX': () => import( /* webpackChunkName: "storm-ui--ChatBoxInput--es-MX" */'./es-MX-0618267e.js'),
  'es-US': () => import( /* webpackChunkName: "storm-ui--ChatBoxInput--es-US" */'./es-US-a3eadf17.js'),
  'fr-CA': () => import( /* webpackChunkName: "storm-ui--ChatBoxInput--fr-CA" */'./fr-CA-76f84ee3.js'),
  'fr-FR': () => import( /* webpackChunkName: "storm-ui--ChatBoxInput--fr-FR" */'./fr-FR-806ff9fd.js'),
  'hi-IN': () => import( /* webpackChunkName: "storm-ui--ChatBoxInput--hi-IN" */'./hi-IN-ff011549.js'),
  'it-IT': () => import( /* webpackChunkName: "storm-ui--ChatBoxInput--it-IT" */'./it-IT-0381c4aa.js'),
  'ja-JP': () => import( /* webpackChunkName: "storm-ui--ChatBoxInput--ja-JP" */'./ja-JP-53db2b42.js'),
  'ko-KR': () => import( /* webpackChunkName: "storm-ui--ChatBoxInput--ko-KR" */'./ko-KR-b3acd76f.js'),
  'nl-NL': () => import( /* webpackChunkName: "storm-ui--ChatBoxInput--nl-NL" */'./nl-NL-39a7a516.js'),
  'pl-PL': () => import( /* webpackChunkName: "storm-ui--ChatBoxInput--pl-PL" */'./pl-PL-409fd0c5.js'),
  'pt-BR': () => import( /* webpackChunkName: "storm-ui--ChatBoxInput--pt-BR" */'./pt-BR-7288e00c.js'),
  'sv-SE': () => import( /* webpackChunkName: "storm-ui--ChatBoxInput--sv-SE" */'./sv-SE-5110824c.js'),
  'ta-IN': () => import( /* webpackChunkName: "storm-ui--ChatBoxInput--ta-IN" */'./ta-IN-8f9758e8.js'),
  'th-TH': () => import( /* webpackChunkName: "storm-ui--ChatBoxInput--th-TH" */'./th-TH-b6bc330c.js'),
  'tr-TR': () => import( /* webpackChunkName: "storm-ui--ChatBoxInput--tr-TR" */'./tr-TR-20845666.js'),
  'vi-VN': () => import( /* webpackChunkName: "storm-ui--ChatBoxInput--vi-VN" */'./vi-VN-fea468f3.js'),
  'zh-CN': () => import( /* webpackChunkName: "storm-ui--ChatBoxInput--zh-CN" */'./zh-CN-1389585b.js'),
  'zh-TW': () => import( /* webpackChunkName: "storm-ui--ChatBoxInput--zh-TW" */'./zh-TW-0d380e16.js')
};
const translationComps = Object.entries(translationImports).reduce((acc, [localCode, importFn]) => ({
  ...acc,
  [localCode]: /*#__PURE__*/lazy(importFn)
}), {});
function getTranslationComponent(locale) {
  return {
    component: locale && locale in translationComps ? translationComps[locale] : DefaultTranslationComp,
    locale: locale && locale in translationComps ? locale : 'en-US',
    translationImports
  };
}

export { getTranslationComponent as g };
//# sourceMappingURL=index-433466f5.js.map
